<script setup>
import { computed } from 'vue';
import { tableRecipe } from './table.recipe';
import { TableProvider } from './useTable';

/**
 * @typedef {import('./table.recipe').TableRecipeVariants} TableRecipeVariants
 */

/**
 * @typedef {object} TableContainerProps
 * @property {TableRecipeVariants['variant']} [variant='default'] - The visual variant of the table container
 * @property {TableRecipeVariants['isHoverable']} [isHoverable=false] - Whether the table rows should have a hover effect
 */

/**
 * @type {TableContainerProps}
 */
const props = defineProps({
  variant: {
    type: String,
    default: 'default',
  },
  isHoverable: {
    type: Boolean,
    default: false,
  },
});

const { container } = tableRecipe();

TableProvider({
  rootProps: computed(() => {
    return {
      variant: props.variant,
      isHoverable: props.isHoverable,
    };
  }),
});
</script>

<template>
  <div data-component="CsTableContainer" :class="container(props)">
    <slot />
  </div>
</template>
